import { Injectable } from '@angular/core';
import {
     ActivatedRouteSnapshot,
     CanActivate,
     CanActivateChild,
     Router,
     RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';
import { DataBootstrapGuard } from './data-bootstrap.guard';

@Injectable()
export class LoggedRouteGuard implements CanActivateChild, CanActivate {
     constructor(
          private router: Router,
          private session: SessionService,
          private dataGuard: DataBootstrapGuard
     ) {}

     async canActivate(
          next: ActivatedRouteSnapshot,
          state: RouterStateSnapshot
     ): Promise<boolean> {
          let sess = this.session.get();
          if (sess) {
               return this.dataGuard.canActivate(next, state);
          } else {
               this.router.navigate(['/']);
               return false;
          }
     }

     canActivateChild(
          next: ActivatedRouteSnapshot,
          state: RouterStateSnapshot
     ): Observable<boolean> | Promise<boolean> | boolean {
          return this.canActivate(next, state);
     }
}
